export interface IStatuses {
  id?: number;
  statusValue?: string;
}

export const defaultValue: Readonly<IStatuses> = {};
